var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg46(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.8853 25.6416C42.2751 19.6453 35.4454 14.7328 27.6383 14.6696C19.8301 14.6051 13.9974 19.4121 14.6101 25.4109C15.224 31.4048 22.0488 36.3172 29.8583 36.3817C37.6678 36.4474 43.4992 31.6367 42.8853 25.6416ZM17.0584 24.1397C16.5239 19.3066 21.5963 15.4261 28.3802 15.4806C35.1603 15.534 41.0947 19.4939 41.6255 24.3245C42.1563 29.1587 37.0901 33.0393 30.3037 32.9885C23.5236 32.9351 17.5905 28.9764 17.0584 24.1397Z",
    fill: "#F8A883"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8495 23.3124C12.3811 27.9854 12.3079 35.1674 16.6858 39.3618C21.0637 43.5549 28.242 43.1654 32.7129 38.4961C37.1838 33.828 37.2532 26.6436 32.8753 22.4467C28.4999 18.2536 21.3229 18.6418 16.8495 23.3124ZM31.0979 36.5069C27.252 40.5189 21.0833 40.855 17.3156 37.251C13.5441 33.6408 13.6086 27.4571 17.4557 23.4401C21.3016 19.4219 27.4753 19.0933 31.2405 22.696C35.0107 26.3038 34.9474 32.4849 31.0979 36.5069Z",
    fill: "#F37C4B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1603_29219",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 5,
    width: 38,
    height: 31
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.9165 5.07373H38.3602V35.3588H1.9165V5.07373Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1603_29219)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.83122 10.85C1.53555 17.4193 -0.577748 26.9428 5.10979 32.1144C10.8048 37.2848 22.1464 36.1549 30.447 29.5844C38.7439 23.0138 40.8547 13.4916 35.1635 8.32123C29.471 3.14465 18.1294 4.27943 9.83122 10.85ZM17.2599 8.27664C25.2567 5.27784 33.1666 8.3126 34.9227 15.0493C36.6813 21.7849 31.6251 29.6812 23.6283 32.6775C15.629 35.6775 7.72276 32.6403 5.96045 25.9048C4.20185 19.1656 9.26061 11.273 17.2599 8.27664Z",
    fill: "#F05A28"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg46);
export default __webpack_public_path__ + "static/media/한화투자증권-46.f9c02f9f4b56183919de74832086c1f8.svg";
export { ForwardRef as ReactComponent };